export const LogoIconRemediumBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M24 10.1047C18.4278 10.1047 13.8953 5.5722 13.8953 0H10.1047C10.1047 5.5722 5.5722 10.1047 0 10.1047V13.8953C5.5722 13.8953 10.1047 18.4278 10.1047 24H13.8953C13.8953 18.4278 18.4278 13.8953 24 13.8953V10.1047ZM12 17.009C10.7924 14.9404 9.05957 13.2076 6.99098 12C9.05957 10.787 10.787 9.05957 12 6.99097C13.213 9.05957 14.9404 10.787 17.009 12C14.9404 13.213 13.213 14.9404 12 17.009Z"
        fill="#2E35FF"
      />
    </svg>
  );
};
